import { Navigate } from 'react-router-dom';

const Dashboard = () => <Navigate to="/sossial" replace />;

export default Dashboard;
